<template>
<b-card title="Login vs Logout">

    <div class="chart-area-container">
        <app-echart-stacked-area  :option-data="option" :style="{ width: '100%' ,height:'300px'}" />
    </div>

</b-card>
</template>

<script>
import { BCard,BCardText } from 'bootstrap-vue'
import AppEchartStackedArea from '@core/components/charts/echart/AppEchartStackedArea.vue'

export default {
components: {
    BCard,
    BCardText,
    AppEchartStackedArea,
},
data() {
  return {
    option: {
      xAxis: {
        type: 'category',
        data: ['7/12', '8/12', '9/12', '10/12', '11/12', '12/12', '13/12', '14/12', '15/12', '16/12', '17/12', '18/12', '19/12', '20/12'],
        show: false,  // Hide x-axis
      },
      yAxis: {
        type: 'value',
        show: false,  // Hide y-axis
      },
      series: [
        {
          name: 'Point one',
          type: 'line',
          stack: 'Total',
          areaStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                { offset: 0, color: '#e84185' },    // Start color (at the top)
                { offset: 1, color: 'rgba(41, 154, 255, 0)' } // End color (transparent at the bottom)
              ]
            },
          },
          color: '#e84185',
          showSymbol: false,
          smooth: 0.4,
          lineStyle: {
            width: 0,
          },
          data: [210, 150, 391, 744, 590, 510, 395, 490, 100, 1200, 1190, 760, 570, 550],
        },
        {
          name: 'Point Two',
          type: 'line',
          stack: 'Total',
          areaStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                { offset: 0, color: '#41ad4a' },    // Start color (at the top)
                { offset: 1, color: 'rgba(41, 154, 255, 0)' } // End color (transparent at the bottom)
              ]
            },
          },
          color: '#41ad4a',
          showSymbol: false,
          smooth: 0.4,
          lineStyle: {
            width: 0,
          },
          data: [200, 32, 281, 634, 490, 430, 310, 450, 900, 1250, 1180, 750, 560, 550],
        },
      ],
    }
  }
}

}
</script>
<style scoped>
    .chart-area-container{
      margin-left: -22px;
      width: 100%;
      height: 16rem;
    }
</style>